import React, { useEffect, useState } from "react";
import { Modal, Tooltip, Collapse } from "antd";
import moment from "moment";
import {
  CalendarMonthOutlined,
  CheckCircleOutline,
  Close,
  InfoOutlined,
} from "@mui/icons-material";

const { Panel } = Collapse;

const FirstTimeModal = ({ previewToggle }) => {
  // STATES
  const [activeAccordion, setActiveAccordion] = useState(0);
  const [modalPreview, showModal] = useState(false);
  const [modalData, setmodalData] = useState(null);

  // CONST VALS
  const { http } = global.services;
  const initLoad = !!+localStorage.getItem("modal");

  // HANDLERS
  const closeHandler = () => {
    localStorage.setItem("modal", 0);
    showModal(false);
  };

  const accordionHandler = (key) => {
    setActiveAccordion(key);
  };

  // HOOKS
  useEffect(() => {
    document.addEventListener("keypress", (event) => {
      let keyCode = event.code;
      if (keyCode === "Enter") closeHandler();
    });
  }, []);

  useEffect(() => {
    if (!initLoad && !previewToggle) return;
    http
      .get("version-update")
      .then(({ data }) => {
        const preview = data?.length > 0;
        if (preview) setmodalData(data);
        if (preview && initLoad) showModal(true);
      })
      .catch(() => {});
  }, [initLoad, previewToggle]);

  return (
    <>
      {previewToggle && modalData && (
        <Tooltip title="Patch Notes" placement="left">
          <button className="release-notes-toggle" onClick={() => showModal(true)}>
            <InfoOutlined />
          </button>
        </Tooltip>
      )}
      <Modal
        visible={modalPreview}
        centered
        width={550}
        className="alpha-notes-modal"
        footer={null}
        onCancel={closeHandler}
        closable={false}
      >
        <button className="close-btn" onClick={closeHandler}>
          <Close />
        </button>
        <div className="top-bar">
          <h2>Conceptor Updates</h2>
          <p>
            Welcome to the platform! Please email{" "}
            <a href="mailto:grayson@conceptor.ai">grayson@conceptor.ai</a> with any
            questions or if anything isn't working as intended.
          </p>
        </div>
        <div className="patch-notes">
          <Collapse accordion activeKey={activeAccordion} onChange={accordionHandler}>
            {modalData?.map((data, index) => (
              <Panel
                key={index}
                header={
                  <>
                    <h3>Version {data?.version_number}</h3>
                    <span className="version-date">
                      <CalendarMonthOutlined />
                      {moment(data?.version_date).format("M/D/YYYY")}
                    </span>
                  </>
                }
              >
                <h4>Patch Notes</h4>
                {data?.updates.length > 0 && (
                  <>
                    <h5>Updates</h5>
                    <ul>
                      {data?.updates.map((update, index) => (
                        <li key={index}>
                          <CheckCircleOutline /> {update}
                        </li>
                      ))}
                    </ul>
                  </>
                )}
                {data?.bugs.length > 0 && (
                  <>
                    <h5 className="modalColor">Bugs</h5>
                    <ul>
                      {data?.bugs.map((bug, index) => (
                        <li key={index}>
                          <CheckCircleOutline />
                          {bug}
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </Panel>
            ))}
          </Collapse>
          <div className="action-box">
            <button className="submit" onClick={closeHandler}>
              Close
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FirstTimeModal;
